import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  IAdminUserRequest,
  IAdminUserResponse,
} from '../../models/user/adminUser.model';
import useHttps from '../useHttps';

const useUser = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const oncreateUserError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const oncreateUserSuccess = ({
    message,
  }: SuccessHttpResponse<IAdminUserResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createUser = (data: IAdminUserRequest) => {
    const url: HttpConfig = {
      url: 'authentication-service/v1/admin',
      method: 'post',
      data,
    };

    request(url, oncreateUserSuccess, setLoading, oncreateUserError);
  };

  return { createUser, loading, resetInputFields };
};

export default useUser;
